import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useTeachingUiStyles = makeStyles({
    calloutRoot: {
        backgroundColor: tokens.colorBrandBackgroundStatic,
        color: tokens.colorNeutralForegroundStaticInverted,
        fontFamily: tokens.fontFamilyBase,
        '& .ms-Callout-main': {
            backgroundColor: tokens.colorBrandBackgroundStatic,
        },
        '& .ms-Callout-beak': {
            backgroundColor: tokens.colorBrandBackgroundStatic,
        },
        '& .ms-TeachingBubble-primaryButton': __assign(__assign({ color: tokens.colorBrandForegroundOnLight, backgroundColor: tokens.colorBrandBackgroundInverted, outlineStyle: 'none' }, shorthands.border('0px', 'none')), { ':hover': {
                color: tokens.colorBrandForegroundOnLightHover,
                backgroundColor: tokens.colorBrandBackgroundInvertedHover,
            }, ':active': {
                color: tokens.colorBrandForegroundOnLightPressed,
                backgroundColor: tokens.colorBrandBackgroundInvertedPressed,
            }, ':focus': __assign({ backgroundColor: tokens.colorBrandBackgroundInverted, outlineStyle: 'none' }, shorthands.border('2px', 'solid', tokens.colorStrokeFocus2)) }),
        '& .ms-TeachingBubble-secondaryButton': __assign(__assign({ color: tokens.colorNeutralStrokeOnBrand2, backgroundColor: tokens.colorSubtleBackgroundInverted, outlineStyle: 'none' }, shorthands.border('1px', 'solid', tokens.colorNeutralStrokeOnBrand2)), { ':hover': {
                backgroundColor: tokens.colorSubtleBackgroundInvertedHover,
            }, ':active': {
                backgroundColor: tokens.colorSubtleBackgroundInvertedPressed,
            }, ':focus': __assign({ outlineStyle: 'none' }, shorthands.border('2px', 'solid', tokens.colorNeutralStrokeOnBrand2)), '& .ms-Button-label': {
                color: tokens.colorNeutralStrokeOnBrand2,
            } }),
        '& .ms-TeachingBubble-closebutton': {
            color: tokens.colorNeutralStrokeOnBrand2,
            outlineStyle: 'none',
            ':hover': {
                backgroundColor: tokens.colorSubtleBackgroundInvertedHover,
            },
            ':active': {
                backgroundColor: tokens.colorSubtleBackgroundInvertedPressed,
            },
            ':focus': __assign({ outlineStyle: 'none' }, shorthands.border('2px', 'solid', tokens.colorNeutralStrokeOnBrand2)),
        },
    },
    calloutRootDark: {
        '& .ms-TeachingBubble-primaryButton': {
            ':focus': __assign({ backgroundColor: tokens.colorBrandBackgroundInverted, outlineStyle: 'none' }, shorthands.border('2px', 'solid', tokens.colorStrokeFocus1)),
        },
    },
    imageContainer: {
        backgroundColor: tokens.colorBrandBackground2,
        width: '100%',
        minHeight: '180px',
    },
});
//# sourceMappingURL=TeachingUiContainerComponent.styles.js.map